<template lang="pug">
  div.legend__group
    div(
      :class="className"
    )
      div.legend__name.semibold {{$translate('Класс опасности')}}
    .legend__small-group
      div(
        v-for="item of list" :key="item.id"
      )
        .custom-checkbox
          input.visually-hidden.custom-checkbox__input(
            type="checkbox"
            :id="'checkbox-danger-' + item.id"
            :value="item.id"
            @change="updateDangerClass"
          )
          label.legend__label.custom-checkbox__label(:for="'checkbox-danger-' + item.id")
            span.custom-checkbox__block
            span.custom-checkbox__text {{$translate(item.id)}}
</template>

<script>
export default {
  name: 'map-danger-class',
  props: {
    className: {
      type: String,
      default: 'legend__type legend__type_with-small',
    },
  },
  data: () => ({
    list: [
      {
        id: 1,
        checked: false,
      },
      {
        id: 2,
        checked: false,
      },
      {
        id: 3,
        checked: false,
      },
      {
        id: 4,
        checked: false,
      },
      {
        id: 5,
        checked: false,
      },
    ],
  }),
  methods: {
    updateDangerClass(event) {
      const selectedItem = this.list.find(
        (item) => item.id === Number(event.target.value)
      )
      selectedItem.checked = !selectedItem.checked
      this.$emit('updateDangerClass', selectedItem)
    },
  },
}
</script>
